import React from "react";
import { getCache, emptyCache, removeFromCache } from "../_global";
import { LoadDisplay } from "../comp/LoadDisplay";

export class LoadOverlay extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            saves: []
        };

        this.load = this.load.bind(this);
        this.clear = this.clear.bind(this);
        this.remove = this.remove.bind(this);
    }

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.open != this.props.open) {
            this.load();
        }
    }

    load() {
        this.setState({ saves: getCache() });
    }

    clear() {
        emptyCache();
        this.load();
    }

    remove(index) {
        removeFromCache(index);
        this.load();
    }


    render() {

        // show/hide
        var classes = "overlay load";

        if(!this.props.open) {
            classes += " hidden";
        }


        // display saves
        var saves = [];

        this.state.saves.map((item, i) => {
            saves.push(
                <LoadDisplay index={i} key={i} data={item} load={this.props.load} remove={this.remove} rename={this.rename} refresh={this.load} />
            );
        });

        if(saves.length == 0) {
            saves.push(
                <div className="error" key={0}>No saved emojis</div>
            );
        }


        return (
            <div className={classes}>
                <div className="overlay-inner">
                    <div className="header">Load Emoji</div>

                    <div className="body">
                        {saves}
                    </div>

                    <div className="footer">
                        <button onClick={this.clear}>Clear All</button>
                        <button onClick={this.load}>Reload</button>
                        
                        <button onClick={this.props.toggle}>X</button>
                    </div>
                </div>
            </div>
        );
    }
}


LoadOverlay.defaultProps = {
    open: false
};
